import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';

/**
 * The parts of `TripDesignerConfig` an experience day's pricing reads,
 * unwrapped so a component under `components/` (banned from importing config
 * directly) can use them. TO sets none of the four, and gets the plain
 * request, no stored response, no price override and repriced extras.
 */
export function useExperiencePricingConfig() {
  const {
    getExperiencePricingFilters,
    getExperiencePriceOverride,
    storesExperiencePricingResponse,
    keepsSavedExtras,
    locale,
  } = useTripDesignerConfig();

  return {
    getExperiencePricingFilters,
    getExperiencePriceOverride,
    storesPricingResponse: !!storesExperiencePricingResponse,
    keepsSavedExtras: !!keepsSavedExtras,
    locale,
  };
}
